import React from 'react';
import { Modal, Button, Input, Form, Space, Typography } from 'antd';

const EmailModal = ({
  isEmailModalVisible,
  handleEmailModalCancel,
  handleSendEmail,
  selectedEmailDocument,
  recipientName,
  setRecipientName,
  recipientEmail,
  setRecipientEmail,
  emailSubject,
  setEmailSubject,
  emailMessage,
  setEmailMessage,
  sending,
}) => {
  return (
    <Modal
      title="Send Document via Email"
      open={isEmailModalVisible}
      onCancel={handleEmailModalCancel}
      footer={[
        <Button key="cancel" onClick={handleEmailModalCancel}>
          Cancel
        </Button>,
        <Button
          key="submit"
          type="primary"
          loading={sending}
          onClick={handleSendEmail}
        >
          Send
        </Button>,
      ]}
      width={600}
    >
      <Space direction="vertical" style={{ width: '100%' }} size="middle">
        {selectedEmailDocument && (
          <div>
            <Typography.Text strong>Selected Document: </Typography.Text>
            <Typography.Text>{selectedEmailDocument.name}</Typography.Text>
          </div>
        )}
        <Form layout="vertical">
          <Form.Item
            label="Recipient Name"
            required
            tooltip="Enter the recipient's full name"
          >
            <Input
              placeholder="John Doe"
              value={recipientName}
              onChange={(e) => setRecipientName(e.target.value)}
            />
          </Form.Item>
          <Form.Item
            label="Recipient Email"
            required
            tooltip="Enter the recipient's email address"
          >
            <Input
              placeholder="john.doe@example.com"
              type="email"
              value={recipientEmail}
              onChange={(e) => setRecipientEmail(e.target.value)}
            />
          </Form.Item>
          <Form.Item
            label="Email Subject"
            required
            tooltip="Enter the email subject"
          >
            <Input
              placeholder="Your Requested File"
              value={emailSubject}
              onChange={(e) => setEmailSubject(e.target.value)}
            />
          </Form.Item>
          <Form.Item
            label="Email Message"
            required
            tooltip="Enter the email message"
          >
            <Input.TextArea
              placeholder="Please find your requested file attached."
              value={emailMessage}
              onChange={(e) => setEmailMessage(e.target.value)}
              rows={4}
            />
          </Form.Item>
        </Form>
      </Space>
    </Modal>
  );
};

export default EmailModal;